import { Box, Typography } from '@mui/material';
import { ReactComponent as UsersIcon } from '@public/images/users.svg';
import { useStyles } from './styles';
import { useMytaverseEvent } from '@core/dashboard/providers';

const ParticipantNumberInfo = () => {
  const classes = useStyles();
  const { participants } = useMytaverseEvent();

  const participantOnlineCount = participants.filter(
    ({ roomId }) => roomId,
  ).length;

  return (
    <Box sx={classes.root}>
      <UsersIcon />
      <Typography sx={classes.text}>
        {participantOnlineCount}/{participants.length}
      </Typography>
    </Box>
  );
};

export default ParticipantNumberInfo;
